






































































import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import Label from '@/components/common/elements/Label.vue';
import InputNoVModel from '@/components/common/elements/InputNoVModel.vue';
import Dialog from '@/components/common/modules/Dialog.vue';
import Tree from '@/components/common/elements/Tree.vue';

@Component({
  components: { InputNoVModel, Label, Dialog, Tree }
})
export default class GroupTreeSelect extends Vue {
  // 選択ボタンの表示・非表示
  @Prop({ default: true })
  private isBtnVisible?: boolean;

  // テキストボックス関連Prop
  // 表示タイプ初期値
  @Prop({ default: 'text' })
  private type?: string;
  // 入力要素name属性
  @Prop({ default: '' })
  private name!: string;
  // 初期値
  @Prop({ default: '' })
  private value?: any;
  // 入力要素最大入力数
  @Prop({ default: '' })
  private maxlength?: string;
  // 入力可能か否か
  @Prop({ default: false })
  private isDisabled?: boolean;
  // 表示のみか否か
  @Prop({ default: false })
  private isReadonly?: boolean;
  // 入力要素プレースホルダ
  @Prop({ default: '' })
  private placeholder?: string;
  // 入力要素名（日本語）
  @Prop({ default: '' })
  private label?: string;
  // バリデーションルールの付与
  @Prop({ default: '' })
  private rules?: string;
  // アイコンの付与
  @Prop({ default: '' })
  private appendIcon?: string;

  // ダイアログ関連Prop
  // ダイアログ表示のタイトル
  @Prop({ default: 'グループ選択' })
  private dialogTitle?: string;
  // 領域外を押下した際の閉じる処理
  @Prop({ default: false })
  private isPersistent?: boolean;
  // ツリービュー要素
  @Prop({ default: () => [] })
  private items?: Array<{ [k: string]: string | any }>;
  // 初期表示でツリーをオープン表示
  @Prop({ default: true })
  private openAll?: boolean;

  // グループ関連付けマスタデータ配列
  @Prop({ default: () => ([]) })
  private body!: Array<any>;

  // ダイアログの表示制御値
  private dialogStatus = false;
  // 「選択する」ボタンの活性制御
  private noneSelectGroupFlag = true;
  // 選択されたグループツリー項目情報
  private selectGroupData: any;

  private dispValue = '';
  /**
   * 初期値の設定
   */
  mounted() {
    if (this.value) {
      const findData = this.body.find((v) => v.i_id === this.value.i_id);
      if (findData) {
        this.dispValue = findData.title;
      }
    }
  }

  @Watch('value')
  onValueChanged() {
    if (this.value) {
      const findData = this.body.find((v) => v.i_id === this.value.i_id);
      if (findData) {
        this.dispValue = findData.title;
      }
    }
  }

  /**
   * 親コンポーネントに選択値を通知する
   * @module inputOperation
   * @return data - 名前と選択グループ項目値
   */
  @Emit('inputOperation')
  public inputOperation(data: any) {
    return data;
  }

  /**
   * 選択されたツリー項目の情報を保持
   * @module catchTreeInput
   */
  public catchTreeInput(data: any) {
    this.selectGroupData = data;
    // 「選択する」ボタンの活性制御
    if (data.length === 0) {
      this.noneSelectGroupFlag = true;
    } else {
      this.noneSelectGroupFlag = false;
    }
  }

  /**
   * 選択するボタン押下
   */
  private selectGroupDialogEvent() {
    // HEXABASEグループツリーの display_id（グループID）からグループ関連付けマスタのデータを検索
    const findData = this.body.find((v) => v.group_id === this.selectGroupData[0].display_id);

    if (findData) {
      // 返却データ（nameとvalueはペイロード情報への設定に使用される）
      // name       : 項目名
      // value      : 選択されたグループに関連付くグループ関連付けマスタアイテムの i_id
      // group_id   : 選択されたグループに関連付くグループ関連付けマスタアイテムの グループID
      // group_name : 選択されたグループに関連付くグループ関連付けマスタアイテムの グループ名
      this.inputOperation({
        'name': this.name,
        'value': findData.i_id,
        'group_id': findData.group_id,
        'group_name': findData.group_name
      });
    } else {
      // TODO: グループ選択エラー
    }
    this.dialogStatus = false;
  }

  /**
   * キャンセルボタン押下
   */
  private cancelGroupDialogEvent() {
    this.dialogStatus = false;
  }
}
